import { Controller } from "@hotwired/stimulus"

// Generic controller for conditionally displaying elements based on input values
// Usage: Add data-controller="conditional-display" to parent element
//        Add data-conditional-display-target="trigger" to the input/select that controls visibility
//        Add data-conditional-display-target="content" to the element(s) to show/hide
//
//        To show content only when trigger matches a specific value:
//        Add data-conditional-display-match-value="Some Value" to the controller element
//        Wire data-action="change->conditional-display#toggleMatch connect->conditional-display#toggleMatch"
export default class extends Controller {
  static targets = ["trigger", "content"]
  static values = { match: String }

  connect() {
    if (this.hasMatchValue) {
      this.toggleMatch()
    } else {
      this.toggle()
    }
  }

  toggle() {
    if (!this.hasContentTarget) return

    const hasValue = this.triggerTarget.value && this.triggerTarget.value !== ''
    this.contentTarget.style.display = hasValue ? 'block' : 'none'
  }

  toggleMatch() {
    if (!this.hasContentTarget) return

    const show = this.triggerTarget.value === this.matchValue
    this.contentTarget.style.display = show ? 'block' : 'none'
    this.contentTarget.querySelectorAll('select, input').forEach(el => { el.required = show })
  }

  toggleRadio() {
    const checked = this.triggerTargets.find(t => t.checked)
    const show = checked?.value === this.matchValue
    this.contentTargets.forEach(el => {
      el.style.display = show ? 'block' : 'none'
      el.querySelectorAll('select, input').forEach(input => { input.required = show; input.disabled = !show })
    })
  }
}
